import { render } from "./SessionTable.vue?vue&type=template&id=62be841c"
import script from "./SessionTable.vue?vue&type=script&lang=ts"
export * from "./SessionTable.vue?vue&type=script&lang=ts"
script.render = render

export default script